import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import 'formiojs/dist/formio.full.css';
import { Form } from '@formio/react';
import "./ViewTemplate.css"

import TemplateService from "../../../Services/TemplateService/TemplateService"
import { HandleApiError } from '../../../Utils/CommonErrors/HandleApiError';
import { useSelector } from 'react-redux';


const ViewTemplate = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [templateData, setTemplateData] = useState([])

  const token = useSelector(
    (state) => state.auth.user.data?.body?.data?.token
  );

  const getTemplate = async () => {
    try {
      const params = {
        id: id
      }
      const response = await TemplateService.getTemplate(params, token)
      const template = response?.data?.body?.data?.templates[0]

      setTemplateData({
        template_name: template.template_name,
        description: template.description,
        tags: template.tags.join(", "),
        form_data: template.form_data,
        id: template.id
      });

    } catch (error) {
      await HandleApiError(error)
    }
  }

  useEffect(() => {
    if (id) {
      getTemplate();
    }
  }, [id]);
  return (
    <>
      <div className="main-inner-block">
        <div className="heading-content">Preview Template</div>
        <div className="content">
          <div className="white-box">

            <div class="d-flex gap-3 create-user-block w-100 justify-content-between">
              <div className="row m-0 w-100">
                <div class="mb-3 col-lg-3 ps-0 padding-right">
                  <label for="template_name" class="form-label">
                    Template Name
                  </label>
                  <div className="form-input-block">
                    {templateData.template_name}
                  </div>
                </div>

                <div class="mb-3 col-lg-3 padding-left">
                  <label for="description" class="form-label">
                    Description
                  </label>
                  <div className="form-input-block">{templateData.description}</div>
                </div>
                <div class="mb-3 col-lg-3 padding-left">
                  <label for="tags" class="form-label">
                    Tags
                  </label>
                  <div className="form-input-block">
                    {templateData.tags}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="main-inner-block">
        <div className="heading-content">Form</div>
        <div className="content">
          <div className="white-box">
            <Form
              form={templateData.form_data}
            />
          </div>
        </div>
      </div >
      <div className="text-center d-flex justify-content-center button-block gap-3">
        <button
          type="submit"
          class="green-btn submit-btn view-btn"
          onClick={() => navigate("/template-listing")}
        >
          Back
        </button>

        <button
          type="submit"
          class="green-btn submit-btn view-btn"
          onClick={() => navigate(`/update-template/${templateData.id}`)}
        >
          Edit Details
        </button>
      </div>
    </>
  )
}

export default ViewTemplate